import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
    distinctId: 'distinct_id_of_the_user',
    event: 'user signed up',
})    
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
  distinctId: 'distinct_id_of_the_user',
  event: 'user signed up',
  properties: {
    login_type: 'email',
    is_free_trial: true,
  },
})
`}</code></pre>
    <h3 {...{
      "id": "capturing-pageviews"
    }}>{`Capturing pageviews`}</h3>
    <p>{`If you're aiming for a backend-only implementation of PostHog and won't be capturing events from your frontend, you can send `}<inlineCode parentName="p">{`$pageview`}</inlineCode>{` events from your backend like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
  distinctId: 'distinct_id_of_the_user',
  event: '$pageview',
  properties: {
    $current_url: 'https://example.com',
  },
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      